<template>
    <div>
        <login-template>
            <template #form-title> Reset Password </template>
            <template #form-paragraph>Please input your email to reset your password.</template>
            <template #form-section>
                <div class="p-fluid">
                    <div class="field">
                        <base-text-input v-model="email" type="email" placeholder="Email" @keyup.enter="resetPassword" :errorMessage="formErrors.email" />
                    </div>
                    <Button label="Reset Password" type="button" @click.prevent="resetPassword" />
                </div>
            </template>
        </login-template>
    </div>
</template>

<script setup>
import LoginTemplate from '../components/LoginTemplate';
import BaseTextInput from '../../custom-inputs/BaseTextInput.vue';

import { ref } from 'vue';
import { ForgotPasswordSchema, handleErrors } from '../../../utilities/schemas';
import { authStore, formErrorStore } from '../../../store/global-stores';
import { showToast } from '../../../utilities/toast-handler';
import { storeToRefs } from 'pinia';

const { formErrors } = storeToRefs(formErrorStore);
const email = ref(null);

const resetPassword = async () => {
    await handleValidation(ForgotPasswordSchema);
    await authStore.forgotPassword(email.value);
};

const handleValidation = async (schema) => {
    try {
        // initiate the loader and submit
        // validate the schema first
        await schema.validate({ email: email.value }, { abortEarly: false });
        formErrorStore.clearErrors();
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            const errors = handleErrors(error);
            formErrorStore.addErrors(errors);
            showToast({}, 'Input data invalid');
        }
    }
};
</script>
